import { all, fork } from "redux-saga/effects";
import userSaga from "./features/user/userSaga";
import billerSaga from "./features/billers/billerSaga";
import billerDetailSaga from "./features/billerDetails/billerDetailSaga";

export default function* rootSaga() {
  yield all([
    fork(userSaga),
    fork(billerSaga),
    fork(billerDetailSaga),
    // fork(walletSaga),
  ]);
}
